// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-title-mode__container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.setting-title-mode__title-input.g-text-input {
  width: 270px;
  margin-left: 12px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/Settings/SettingTitleMode/SettingTitleMode.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;AAAR;AAGI;EACI,YAAA;EACA,iBAAA;AADR","sourcesContent":[".setting-title-mode__container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.setting-title-mode__title-input.g-text-input {\n  width: 270px;\n  margin-left: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
